import { c as _c } from "react/compiler-runtime";
import { Link01Icon } from '@systemeio/icons';
import { BadRequest } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelTabCard } from 'modules/funnels/funnel/components/funnel-tab-card';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useRemoteFormSettings } from 'modules/funnels/funnel/hooks/use-remote-form-settings';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { RemoteFormEditInterface, RemoteFormFieldErrorResponseContentInterface, RemoteFormFieldErrorsInterface, RemoteFormInterface } from 'modules/funnels/funnel/types/remote-form-interface';
import { getScriptTagHtmlCode } from 'modules/funnels/funnel/utils/remote-form-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useEffect, useState } from 'react';
import { Button, FormInputGroup } from 'shared/components';
import LinkShareModal from 'shared/components/link-share-modal';
import { FunnelStepTypeEnum } from 'shared/enums/funnel-step-type-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getStateStatusIcon } from 'shared/utils/get-status-icon';
import { useFunnelStepsList } from '../../../hooks/use-funnel-steps-list';
import { useBaseConfigurationTabFieldState, useUpdateBaseConfigurationTab } from '../../../hooks/use-update-base-configuration-tab';
import CreateRemotePopupLinkModal from './create-remote-popup-link-modal';
const defaultValues: RemoteFormEditInterface = {
  name: ''
};
const defaultErrors: RemoteFormFieldErrorsInterface = {
  name: ''
};
interface RemoteFormConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function RemoteFormConfigurationTab(t0) {
  const $ = _c(68);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    remoteFormSettings,
    mutateRemoteFormSettings
  } = useRemoteFormSettings(funnelStep.id);
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultErrors);
  const [openedScriptModal, setOpenedScriptModal] = useState(false);
  const [openedLinkModal, setOpenedLinkModal] = useState(false);
  const isScriptModalVisible = !!(funnel && funnel.domain.domainName && remoteFormSettings && remoteFormSettings.page.hash);
  const t1 = `${FUNNELS_API}/step-remote-form/${funnelStep.id}`;
  let t2;
  if ($[0] !== funnelId || $[1] !== funnelStep.id || $[2] !== t1) {
    t2 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t1
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    updateFetcher,
    isFetching
  } = useUpdateBaseConfigurationTab(t2);
  const isPopup = funnelStep.type === FunnelStepTypeEnum.Popup;
  const [savedState, setSavedState] = useState(defaultValues);
  let t3;
  if ($[4] !== savedState || $[5] !== tempState) {
    t3 = {
      savedState,
      currentState: tempState
    };
    $[4] = savedState;
    $[5] = tempState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    isNameChanged,
    successState,
    setSuccessState
  } = useBaseConfigurationTabFieldState(t3);
  let t4;
  if ($[7] !== funnelStep.id || $[8] !== isNameChanged || $[9] !== mutateFunnelStepsList || $[10] !== mutateRemoteFormSettings || $[11] !== setSuccessState || $[12] !== tempState || $[13] !== updateFetcher) {
    t4 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        await updateFetcher(tempState, async () => {
          setSuccessState(prev_0 => ({
            ...prev_0,
            name: isNameChanged
          }));
          setSavedState(prev_1 => ({
            ...prev_1,
            name: isNameChanged
          }));
          await mutateRemoteFormSettings(data => {
            if (data) {
              return {
                ...data,
                name: tempState.name
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: tempState.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t5) {
        const e = t5;
        if (e instanceof BadRequest) {
          if (e.errors.fields) {
            const errors_0 = e.errors.fields as unknown as RemoteFormFieldErrorResponseContentInterface;
            setErrors(prev => ({
              ...prev,
              name: errors_0.name?.join("")
            }));
          }
        }
      }
    };
    $[7] = funnelStep.id;
    $[8] = isNameChanged;
    $[9] = mutateFunnelStepsList;
    $[10] = mutateRemoteFormSettings;
    $[11] = setSuccessState;
    $[12] = tempState;
    $[13] = updateFetcher;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const handleSave = t4;
  let t5;
  let t6;
  if ($[15] !== remoteFormSettings) {
    t5 = () => {
      if (remoteFormSettings) {
        setTempState(prev_2 => ({
          ...prev_2,
          name: remoteFormSettings.name
        }));
        setSavedState(prev_3 => ({
          ...prev_3,
          name: remoteFormSettings.name
        }));
      }
    };
    t6 = [remoteFormSettings];
    $[15] = remoteFormSettings;
    $[16] = t5;
    $[17] = t6;
  } else {
    t5 = $[16];
    t6 = $[17];
  }
  useEffect(t5, t6);
  if (!remoteFormSettings || !funnel || !funnelStep.page) {
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <TabContentLoader />;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    return t7;
  }
  let t7;
  if ($[19] !== t) {
    t7 = t("global.name");
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = tempState.name;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setTempState(prev_4 => ({
      ...prev_4,
      name: e_0.target.value
    }));
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleSave || $[23] !== isNameChanged) {
    t10 = () => isNameChanged && handleSave();
    $[22] = handleSave;
    $[23] = isNameChanged;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = isFetching && isNameChanged;
  let t12;
  if ($[25] !== successState.name || $[26] !== t11) {
    t12 = getStateStatusIcon(t11, successState.name);
    $[25] = successState.name;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== errors.name || $[29] !== t10 || $[30] !== t12 || $[31] !== t7 || $[32] !== tempState.name) {
    t13 = <FormInputGroup required={true} label={t7} value={t8} onChange={t9} onBlur={t10} maxLength={256} statusIcon={t12} error={errors.name} />;
    $[28] = errors.name;
    $[29] = t10;
    $[30] = t12;
    $[31] = t7;
    $[32] = tempState.name;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setOpenedScriptModal(true);
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = !isScriptModalVisible;
  let t16;
  if ($[35] !== t) {
    t16 = t("dashboard.funnel.configuration.remote.script");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16) {
    t17 = <span>{"</>"} {t16}</span>;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t15 || $[40] !== t17) {
    t18 = <Button className="max-w-fit" onClick={t14} disabled={t15} variant="tertiary-color" size="sm">{t17}</Button>;
    $[39] = t15;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== isPopup || $[43] !== t) {
    t19 = isPopup && <Button className="max-w-fit" onClick={() => setOpenedLinkModal(true)} variant="tertiary-gray" size="sm"><Link01Icon /><span>{t("dashboard.funnel.configuration.remote.create_link")}</span></Button>;
    $[42] = isPopup;
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t18 || $[46] !== t19) {
    t20 = <div className="desktop:gap-3 flex gap-2">{t18}{t19}</div>;
    $[45] = t18;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t13 || $[49] !== t20) {
    t21 = <FunnelTabCard className="desktop:gap-3 flex flex-col gap-2">{t13}{t20}</FunnelTabCard>;
    $[48] = t13;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== funnel || $[52] !== funnelStep.id || $[53] !== isScriptModalVisible || $[54] !== openedScriptModal || $[55] !== remoteFormSettings || $[56] !== t) {
    t22 = isScriptModalVisible && <LinkShareModal link={getScriptTagHtmlCode(funnel.domain.domainName, remoteFormSettings.page.hash, funnelStep.id)} label="" title={t("dashboard.funnel.configuration.remote.script_tag")} opened={openedScriptModal} onClose={() => setOpenedScriptModal(false)} />;
    $[51] = funnel;
    $[52] = funnelStep.id;
    $[53] = isScriptModalVisible;
    $[54] = openedScriptModal;
    $[55] = remoteFormSettings;
    $[56] = t;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== funnel || $[59] !== funnelStep.id || $[60] !== isPopup || $[61] !== openedLinkModal || $[62] !== remoteFormSettings) {
    t23 = isPopup && <CreateRemotePopupLinkModal opened={openedLinkModal} onClose={() => setOpenedLinkModal(false)} domainName={funnel.domain.domainName} pageHash={remoteFormSettings.page.hash} funnelStepId={funnelStep.id} />;
    $[58] = funnel;
    $[59] = funnelStep.id;
    $[60] = isPopup;
    $[61] = openedLinkModal;
    $[62] = remoteFormSettings;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== t21 || $[65] !== t22 || $[66] !== t23) {
    t24 = <>{t21}{t22}{t23}</>;
    $[64] = t21;
    $[65] = t22;
    $[66] = t23;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  return t24;
}
export default RemoteFormConfigurationTab;